/*
 *   File : primary.js
 *   Author : https://evoqins.com
 *   Description : Primary button component
 *   Integrations : NA
 *   Version : 1.0.0
*/
import React, { memo } from 'react';

const PrimaryButton = ({
    onClick = () => { },
    className = '',
    id,
    name,
    paddingBlock = 'padding-16px-tb padding-12px-lr',
    toggle,
    target,
    cancel,
    dismiss,
    disabled,
    loader,
}) => (
    <button
        className={`${className} ${disabled ? "pe-none opacity-50" : ""} ${loader ? "pe-none" : ""} ${paddingBlock} m-0 border-radius-8 border-0 e-bg-blue-violet e-font-14 e-primary-font e-text-white e-font-weight-600 line-height-16px`}
        data-bs-toggle={toggle}
        data-bs-target={target}
        data-bs-cancel={cancel}
        data-bs-dismiss={dismiss}
        disabled={disabled}
        id={id}
        onClick={onClick}
    >
        {loader ? (
            <img
                src={require("../../Assets/Image/btn-loader.gif")}
                draggable={false}
                width={24}
                height={14}
                alt="loader"
            />
        ) : (
            <span>{name}</span>
        )}
    </button>
);

export default memo(PrimaryButton);
